import React from 'react'
import { useQuery } from "react-query";
import { getDoctors } from "../Components/Api/api"

const useGetDoctors = () => {

    const GetAllDoctors = useQuery("GetAllDoctors", () =>
        getDoctors()
    );

    let Doctors_list = "";

    if (GetAllDoctors?.data) {
        Doctors_list = GetAllDoctors?.data.map((item, index) => (
            <option className="item" key={index} value={item.idAuth}>
                {item.user_name}
            </option>
        ));
    }


    return (
        { Doctors_list }
    )
}

export default useGetDoctors